<div class="flex items-center bg-[#EBF6FB] h-[65px] rounded w-full p-2 justify-between ion-activatable relative overflow-hidden cursor-pointer">
  <ion-ripple-effect></ion-ripple-effect>
  <div class="flex items-center gap-3">
    <div
      class="h-12 w-12 rounded-md image"
      [ngStyle]="{ background: 'url(' + (category.image ? category.image : 'assets/icons/icon-96.webp') + ')' }"
    ></div>
    <ion-label
      class="text-[14px] font-semibold"
      color="secondary"
    >
      {{ category.name }}
    </ion-label>
  </div>
  <ion-icon
    name="chevron-forward-outline"
    color="secondary"
  ></ion-icon>
</div>
